
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("auth", ["profile"]),
    refreshPage() {
      if (this.isAndroid()) {
        Android.appReload();
      } else {
        location.reload();
        // this.profile();
      }
    }
  }
};
